import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { CustomerSelectionModule } from '@next/arable-lib/customer-selection';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { IgnoreStatusOfflinePatterns } from '@next/core-lib/components';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { CopyCropFieldsToManureSpaceModule } from './copy-cropfields-to-manure-space/copy-cropfields-to-manure-space.module';
import { FieldPlanCustomerSelectionCustomConfigComponent } from './customer-selection-custom-config/customer-selection-custom-config.component';
import { RegistrationModule } from './registration/registration.module';
import { ReportsModule } from './reports/reports.module';
import { SharedModule } from './shared/shared.module';
import { SoilAnalysisNotificationEffects } from './soil-analysis/store/soil-analysis-notification.effects';
import { AppEffects } from './store/effects';
import { appReducer } from './store/reducer';

import { UpdateNvgModule } from './update-nvg/update-nvg.module';

@NgModule({
  declarations: [AppComponent, FieldPlanCustomerSelectionCustomConfigComponent],
  imports: [
    RouterModule,
    SharedModule,
    RegistrationModule,
    ReportsModule,
    MatIconModule,
    AgrWrapperSiteSidenavModule,
    CopyCropFieldsToManureSpaceModule,
    CustomerSelectionModule,
    UpdateNvgModule,
  ],
  providers: [
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),
    provideState('app', appReducer),
    provideEffects([AppEffects]),
    provideEffects([SoilAnalysisNotificationEffects]),
    {
      provide: IgnoreStatusOfflinePatterns,
      useValue: ['/arable-service/organisation/customerprogress'],
      multi: true,
    },
  ],
})
export class AppModule {}
